
function Footer() {
  return(
    <footer className="Footer">
      <div className="Footer__content">
        <p>Created by SovereinPr Team</p>
      </div>
    </footer>
  )
}

export default Footer;